import React, {FC} from "react"
import {ApolloProvider, ApolloProviderProps} from "react-apollo"
import {ApolloProvider as HooksProvider} from "@apollo/react-common"

/**
 * Until we migrate to client v3, we are just passing the same client to both Providers
 * This is needed because they have their own contexts, for hooks and Components
 */
export const Provider: FC<ApolloProviderProps<any>> = React.memo(function ApolloWrapper({children, ...props}) {
  return (
    <ApolloProvider {...props}>
      <HooksProvider {...props}>{children}</HooksProvider>
    </ApolloProvider>
  )
})
